import { type Vendor } from '@webapp/models'
import { Address } from '../Address'

export interface IVendorAddressProps {
  vendor: Vendor
}

export const VendorAddress = ({ vendor }: IVendorAddressProps) => {
  return (
    <Address
      addressOne={vendor.addressLineOne}
      addressTwo={vendor.addressLineTwo}
      city={vendor.city}
      country={vendor.country}
      postalCode={vendor.postalCode}
      stateProvince={vendor.state_province}
    />
  )
}

VendorAddress.displayName = 'VendorAddress'
